import React from "react";
import { Modal, List } from "antd";

/**
 * Se abre cuando un GTIN resuelve a más de un artículo (detart con N > 1).
 * Pinta idartl; cuando el backend agregue `nombre` pasa a pintarlo de título
 * sin tocar este archivo.
 */
const ModalSeleccionSku = ({ open, items, onCancel, onSelect }) => (
  <Modal
    open={open}
    title="Seleccione artículo"
    footer={null}
    onCancel={onCancel}
  >
    <List
      dataSource={items}
      renderItem={(item) => (
        <List.Item
          onClick={() => onSelect(item)}
          style={{
            cursor: "pointer",
            padding: "12px 8px",
          }}
        >
          <List.Item.Meta
            title={item.nombre || item.codigo}
            description={
              item.nombre
                ? [item.modelo, item.codigo].filter(Boolean).join(" • ")
                : item.modelo
            }
          />
        </List.Item>
      )}
    />
  </Modal>
);

export default ModalSeleccionSku;